<template>
  <cTable
    style="height: calc(100vh - 200px)"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs v-model="type" @on-click="handleTab" :name="name">
        <TabPane
          v-for="(item, idx) in customs"
          :key="idx"
          :tab="name"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/b2borderStatistics";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    customs: {
      type: Array,
      default() {
        return [];
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      {
        type: "checkbox",
        width: 50,
        align: "center"
      },
      ...this.headers
    );
    console.log("mounted");
  },
  methods: {
    handleTab(tab) {
      this.type = tab;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    }
  },
  data() {
    return {
      type: "index",
      methods: {
        ...apis,
        list: p => {
          p.type = this.type;
          return apis[this.name](p);
        },
        beforeHandleList: ({ data }) => {
          data.header.forEach(t => (t.minWidth = 110));
          this.fields = data.header;
          return data.rows;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: []
    };
  }
};
</script>

<style scoped></style>
